export default function request(state = {}, action) {
  if (action.request) {
    const currentRequestNum = (state[action.request.id] && state[action.request.id].numRequests) || 0;
    const numRequests = action.type.includes('_START') ? currentRequestNum + 1 : currentRequestNum - 1;

    return {
      ...state,
      [action.request.id]: {
        isPending: numRequests > 0,
        error: action.request.error,
        // Just in case more error or success actions are kicked off than there should be...git c
        numRequests: numRequests > 0 ? numRequests : 0
      }
    };
  }

  return state;
}

/**
 * @name getPendingStatus
 * @param state
 * @param {string, array} requestId or array of requestIds
 * @return {boolean}
 */
export const getPendingStatus = (state, requestIds = []) => {
  const ids = Array.isArray(requestIds) ? requestIds : [requestIds];

  return ids.some(id => (state.request[id] || {}).isPending === true);
};
